import React, { useEffect, useMemo, useState } from "react";
import styles from "./WorkflowModels.module.css";
import { useApi } from "../../../../../../common/hooks";
import { AiWorkflowService } from "../../../../../../api";
import { InfiniteList2, SearchInput } from "../../../../../../common/components";
import ModelRow from "./ModelRow";
import HeaderRow from "./HeaderRow";
import { translate } from "../../../../../../common/providers";
import { debounce } from "../../../../../../common/utils";

const debounceFunc = debounce((func) => func(), 500);

const WorkflowModels = () => {
	const { call: getDefinitionList } = useApi(AiWorkflowService.getDefinitionList);
	const [infiniteListRequest, setInfiniteListRequest] = useState(null);
	const [activeSortKey, setActiveSortKey] = useState("");
	const [sortDirection, setSortDirection] = useState("desc");
	const [name, setName] = useState("");
	const [nameDebounced, setNameDebounced] = useState("");
	const headers = useMemo(
		() => [
			{ name: "common:field.id", sortKey: "id", className: "rowId" },
			{ name: "common:field.name", sortKey: "name", className: "rowTitle" },
			{ name: "common:field.description", className: "rowDescription" },
			{ name: "common:field.created", className: "rowCreated" },
		],
		[]
	);
	useEffect(() => {
		setInfiniteListRequest(
			() =>
				({ page, limit }) =>
					getDefinitionList({
						page,
						size: limit,
						sort: [activeSortKey, sortDirection],
						titleContains: nameDebounced,
					})
		);
	}, [getDefinitionList, activeSortKey, sortDirection, nameDebounced]);
	const handleClickSort = (newKey) => {
		if (activeSortKey === newKey) {
			setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
		} else {
			setActiveSortKey(newKey);
			setSortDirection("desc");
		}
	};
	const handleChangeSearchValue = (e) => {
		const { value } = e.target;
		setName(value);
		debounceFunc(() => setNameDebounced(value));
	};
	const handleClearSearchValue = () => {
		setName("");
		setNameDebounced("");
	};
	const rowRenderer = (workflow) => <ModelRow key={workflow.id} workflow={workflow} />;
	return (
		<div className={styles.container}>
			<div className={styles.filterContainer}>
				<SearchInput
					className={styles.searchContainer__textfield}
					label={translate("common:btn.search")}
					value={name}
					onChange={handleChangeSearchValue}
					onClearSearch={handleClearSearchValue}
				/>
			</div>
			<HeaderRow
				activeSortKey={activeSortKey}
				headers={headers}
				sortDirection={sortDirection}
				onClickSort={handleClickSort}
			/>
			<div className={styles.list}>
				<InfiniteList2 request={infiniteListRequest} rowRenderer={rowRenderer} />
			</div>
		</div>
	);
};

export default WorkflowModels;
